import './App.css';
import Main from './views/main/Main';

function App() {
  return (
    <div className="App">
      <Main />
    </div>
  );
}

export default App;
